import React from 'react';

/**
 * Decorative wavy divider line used under titles and headings across the site.
 */
export default function WaveDivider({
  className = 'text-[#C68D94]/60 mx-auto mb-6',
  width = 54,
  height = 8,
}) {
  return (
    <svg
      className={`block ${className}`}
      width={width}
      height={height}
      viewBox="0 0 52 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M2 4 C6 1, 10 1, 14 4 C18 7, 22 7, 26 4 C30 1, 34 1, 38 4 C42 7, 46 7, 50 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
